export enum TransactionConsumerPlanStatus {
  TCPS_UNSET_STATE = 'TCPS_UNSET_STATE', // Do not use, needed because of proto3 limitations
  TCPS_ACTIVATED = 'TCPS_ACTIVATED',
  TCPS_CLOSED = 'TCPS_CLOSED',
  TCPS_TERMINATED = 'TCPS_TERMINATED',
}
